import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { ClickAwayListener } from "@mui/material";
import { useState, useEffect, useRef, useCallback, useMemo, isValidElement, cloneElement } from "react";
import { MobileSelectDialog } from "./components/MobileSelectDialog.js";
import { useBreakpoint } from "../../hooks/useBreakpoint.js";
import { CloseReasons } from "./types/enums.js";
import { ContextProvider } from "./context/ContextProvider.js";
import { useClickAwayCallback } from "./useClickAwayCallback.js";
import { DropdownWindow } from "./DropdownWindow.js";
import { DDHeight } from "./types/DDHeight.js";
import { DDWidth } from "./types/DDWidth.js";
const dummyFn = () => {
}, isOptValue = (val) => val && typeof val == "object" && "label" in val, isOptValueArray = (val) => val && Array.isArray(val) && val[0] && typeof val[0] == "object" && "label" in val[0], Dropdown = ({
  disabled,
  children,
  value,
  onChange,
  onClose,
  onCloseMobile,
  name,
  noMobileView,
  mobileHeader,
  onReachEnd,
  onReachEndThreshold,
  dropdownFooterRow,
  dropdownHeaderRow,
  renderValue,
  mobileBackButton,
  renderAnchorComponent,
  multiple = !1,
  placement,
  maxHeight = DDHeight.MD,
  width = DDWidth.SM,
  filter
}) => {
  const [el, setElement] = useState(null), handleContainerClick = (e) => {
    !el && !disabled && setElement(e.currentTarget);
  }, { xsOnly } = useBreakpoint("xs"), mobileViewEnabled = xsOnly && !noMobileView, open = !!el;
  useEffect(() => {
    setElement(null);
  }, [mobileViewEnabled]);
  const cbRefs = useRef({ onClose, onCloseMobile });
  cbRefs.current.onClose = onClose, cbRefs.current.onCloseMobile = onCloseMobile;
  const handleClose = useCallback((reason) => {
    var _a, _b;
    setElement(null), (_b = (_a = cbRefs.current).onClose) == null || _b.call(_a, reason);
  }, []), handleCloseMobile = useCallback(() => {
    var _a, _b;
    handleClose(CloseReasons.CANCEL), (_b = (_a = cbRefs.current).onCloseMobile) == null || _b.call(_a);
  }, [handleClose]), handleClickAway = useClickAwayCallback(
    open ? () => {
      handleClose(CloseReasons.CANCEL);
    } : dummyFn
  ), renderValueRef = useRef(renderValue);
  renderValueRef.current = renderValue;
  const inputValue = useMemo(() => {
    let inputValue2;
    if (multiple && Array.isArray(value))
      if (isOptValueArray(value))
        inputValue2 = value.map((v) => v.label);
      else {
        const render = renderValueRef.current;
        inputValue2 = (render == null ? void 0 : render(value)) ?? value;
      }
    else if (isOptValue(value))
      inputValue2 = [value.label];
    else {
      const render = renderValueRef.current;
      inputValue2 = render ? [render(value)] : [value];
    }
    return inputValue2;
  }, [multiple, value]);
  let anchorComponent = renderAnchorComponent({
    open,
    name,
    value: inputValue,
    mobileView: !!mobileViewEnabled,
    disabled
  });
  isValidElement(anchorComponent) ? anchorComponent = cloneElement(
    anchorComponent,
    {
      onClick: handleContainerClick
    }
  ) : console.error("[Dropdown] Invalid element provided as anchorComponent");
  const listHeaderContent = dropdownHeaderRow, listFooterContent = dropdownFooterRow;
  let renderContent;
  mobileViewEnabled ? renderContent = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    anchorComponent,
    /* @__PURE__ */ jsx(
      MobileSelectDialog,
      {
        open,
        header: mobileHeader,
        handleClose,
        handleCloseMobile,
        listHeaderContent,
        listFooterContent,
        onReachEndThreshold,
        onReachEnd,
        mobileBackButton,
        children
      }
    )
  ] }) : renderContent = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: handleClickAway, children: /* @__PURE__ */ jsx(
      DropdownWindow,
      {
        placement,
        open,
        anchorEl: el,
        headerContent: listHeaderContent,
        footerContent: listFooterContent,
        reachEndThreshold: onReachEndThreshold,
        onReachEnd,
        maxHeight,
        width,
        children
      }
    ) }),
    /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: handleClickAway, children: anchorComponent })
  ] });
  const val = useMemo(
    () => value ? Array.isArray(value) ? value : [value] : void 0,
    [value]
  );
  return /* @__PURE__ */ jsx(
    ContextProvider,
    {
      name,
      value: val,
      filter: filter ?? "",
      mobileView: mobileViewEnabled,
      onChange,
      onClose: handleClose,
      multi: multiple,
      children: renderContent()
    }
  );
};
export {
  Dropdown
};
//# sourceMappingURL=Dropdown.js.map
